import React from 'react';

import { PrismicRichText } from 'types/prismicRichtext';
import { linkResolver } from 'utils/linkResolver';

import { asText } from 'components/rich-text/RichText';
import { Image } from 'components/image/Image';
import { PrismicImageGridFields } from 'types/prismicSlices';
import { ImageList } from 'components/image-list/ImageList';
import { IPrismicImage } from 'types/prismicImage';
import { ImageListItem } from 'components/image-list/ImageListItem';

interface IListContainer {
  title: PrismicRichText;
  items: PrismicImageGridFields[];
  isColumnLayout: boolean;
}

export const ImageListContainer = ({ title, isColumnLayout, items }: IListContainer) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <ImageList title={title ? asText(title) : undefined} isColumnLayout={isColumnLayout}>
      {items.map((item: PrismicImageGridFields, i: number) => {
        const image: IPrismicImage = item.image1;

        if (!image) {
          return null;
        }

        const { dimensions, alt, url, copyright } = image;

        let width;
        let height;
        let isPortrait = true;

        if (dimensions) {
          width = dimensions.width;
          height = dimensions.height;
          isPortrait = width <= height;
        }

        return (
          <ImageListItem key={i} link={item.link ? linkResolver(item.link) : undefined}>
            <Image width={width} height={height} alt={alt} copyright={copyright} url={url} />
          </ImageListItem>
        );
      })}
    </ImageList>
  );
};
